import React, { useContext } from 'react';
import { WelcomeCardContext } from '../../../contexts';
import { getImageURL, getHostCURL } from '../../../common/utils/CardUtils';
import './WelcomeCardHeader.scss';

export const WelcomeCardHeader = () => {
  const RHLink = '/myaccount/proXtraRewards';
  const year = new Date().getFullYear();
  const { userData, isAdmin } = useContext(WelcomeCardContext);
  const proTiers = userData && userData.proTiers;
  const currentTierName = proTiers?.currentTierName || 'MEMBER';
  let tierImage;
  if (currentTierName === 'MEMBER') {
    tierImage = 'Tier-Badge-X-Member.svg';
  } else if (currentTierName === 'VIP') {
    tierImage = 'Tier-Badge-X-VIP.svg';
  } else if (currentTierName === 'Elite') {
    tierImage = 'Tier-Badge-X-Elite.svg';
  } else {
    tierImage = 'Tier-Badge-X-Member.svg';
  }
  return (
    <div className="sui-grid">
      <a
        href={isAdmin ? getHostCURL(RHLink) : undefined}
        rel=" noreferrer"
        className="header-container"
      >
        <div className="header-badge">
          <img
            className="header-badge-image"
            src={getImageURL(tierImage)}
            alt="header-icon"
            height="auto"
            width="auto"
          />
          <div className={`member-background member-background-color-${currentTierName}`}>
            <div>
              <img
                src={getImageURL('ProTiers/Pro-Xtra-logo-text.svg')}
                alt="logo-text"
                height="12"
                width="57"
                className="proxtraLogo"
              />
            </div>
            <div className="badge-text-tier">{currentTierName.toUpperCase()}</div>
          </div>
        </div>
      </a>
    </div>
  );
};
